import React from 'react';

var PushConfirmPopup = React.createClass({
	componentDidMount: function() {
    	// $('.modal__content').css({'position': 'fixed'});
  	},
	handleCloseClick: function (){
		this.props.confirmPush("close");
	},
	handlePushClick: function() {
		this.props.confirmPush("submit");
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function() {
		return (
			<div className="modal__mask"  onClick = {this.handleCloseClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Overwrite Files?</h3>
				    <a href="javascript:void(0)" className="modal__close"><i className="fa  fa-close" onClick = {this.handleCloseClick}> </i></a> </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Changes have been made in the hub since your last pull. Pushing will overwrite files with old versions. Do you want to push anyway? (You will be given the chance to review individual files before they are overwritten.)</p>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
				      <button className="btn__lg bg-dark" onClick = {this.handlePushClick}>Push</button>
				    </div>
				  </div>
				</div>
			</div>
			);
	}
});

export {PushConfirmPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/PushConfirmPopup.jsx
 **/